export const getMetadataCues = (textTracks: TextTrackList): TextTrackCueList | null => {
  const metadataTrack = [...textTracks].find((({ kind }) => kind === 'metadata'));

  return metadataTrack?.cues || null;
};